const createLogicalCompositorWith = (method: string) => (
  ...predicates: any
) => (...args: []) =>
  predicates[method]((predicate: any) => predicate(...args));

export default createLogicalCompositorWith;
